import { render } from "./IssueFeedback.vue?vue&type=template&id=6c810ce3&scoped=true"
import script from "./IssueFeedback.vue?vue&type=script&lang=js"
export * from "./IssueFeedback.vue?vue&type=script&lang=js"

import "./IssueFeedback.vue?vue&type=style&index=0&id=6c810ce3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c810ce3"]])

export default __exports__